function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Object, isPrimary) {
    var h = require("panel").h;
    const theme = $attr(`theme`);;
    const content = $component.innerHTML.trim();;
    const iconOnly = !content && !!$attr(`icon`) || content.length === 1;;
    const isDestructive = $attr(`type`) === `destructive` || $attr(`icon`) === `trashcan`;;
    const isPressed = $attr(`pressed`);;
    return {
      value: (h("div", {
        "attrs": $helpers.getButtonAttrs(),
        "class": Object.assign({}, {
          [`mp-button-${theme}`]: true,
          [`type-${$attr(`type`)}`]: true,
          'type-destructive': isDestructive,
          'is-icon-only': iconOnly,
          'is-pressed': isPressed,
        }, {
          'mp-button-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-button-animation-layer': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-button-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`icon`) === `spinner`) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
              "key": `button-spinner`,
              "attrs": {
                color: isPrimary && !$attr(`disabled`) ? `white` : `blue`
              },
            }));;
            return __jade_nodes
          }).call(this)) : ($attr(`icon`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "key": `button-icon`,
              "attrs": {
                icon: $attr(`icon`)
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!(!content)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "class": {
                'mp-button-content-text': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "isPrimary" in locals ? locals.isPrimary : typeof isPrimary !== "undefined" ? isPrimary : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;